module.exports = __webpack_public_path__ + "img/display_1200_628.15be486b.jpg";